import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  mainTitleStyle: theme => ({
    color: theme.colors.textColorThree,
    marginLeft: 16,
    marginTop: 10,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 0,
    lineHeight: 30,
    flexShrink: 1,
  }),
  itemContainerViewStyle: { marginTop: 11 },
  itemTitleStyle: { marginBottom: 2 },
  itemImageStyle: { height: 100, width: '60%', marginTop: -70 },
});
